import { MatchListController } from "./match-list.controller";

const matchListBlockComponent = {
	bindings: {},
	template: require("./external-match-list.html"),
	controller: MatchListController,
	controllerAs: "mlc",
};

export default matchListBlockComponent;